import { styled } from "@mui/material/styles";
const Slot = styled("div")(() => ({
  width: 64,
  height: 40,
  borderRadius: 4,
  fontSize: 14,
  fontWeight: 500,
  marginRight: 2,
  marginLeft: 1,
  marginBottom: 8,
  textAlign: "center",
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}));
const NoSlotDash = styled("svg")(() => ({
  width: 18,
  height: 2,
  fill: "#DEE1E4",
  stroke: "#DEE1E4",
  rect: {
    width: 18,
    height: 2,
    fill: "#DEE1E4",
    stroke: "#DEE1E4"
  }
}));
export {
  NoSlotDash,
  Slot
};
